import LoginMain from "@/assets/LoginMain.svg";

const LoginLeft: React.FC = () => {
  return (
    <div className="relative flex w-full items-center justify-center bg-neutral-100 px-16 py-28">
      <div className="h-full w-fit">
        <img
          src={LoginMain.src}
          alt="QR Code"
          className="h-full w-full object-contain"
        />
      </div>
    </div>
  );
};

export default LoginLeft;
